import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { State } from 'vuex-class';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppDatePicker from '@/components/AppDatePicker.vue';
import AppDialog from '@/components/AppDialog.vue';
import AppTextField from '@/components/AppTextField.vue';
import AppSelector from '@/components/AppSelector.vue';
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue';
import AppSearchBtn from '@/components/AppSearchBtn.vue';
import AppSimpleSelector from '@/components/AppSimpleSelector.vue';
import AppSimpleTextField from '@/components/AppSimpleTextField.vue';
import { showErrors, showNotification } from '@/utils/snack';
import ListPage from '@/mixins/list-page';
import GoodsDialog from './script-dialog';
import { findGoods, changeGoodsStatus, openOrCloseStore, exportGoodsList } from './gql';
import { SnackType } from '@/interfaces/snack';
import { GoodsOrderBy } from '@/interfaces/goods';
import AuthFilter from '@/mixins/auth-filter';
import { formatCurrency } from '@/utils/currency';
import { downloadBase64 } from '@/helpers/base64-to-file';

var GoodsList = /*#__PURE__*/function (_mixins) {
  _inherits(GoodsList, _mixins);

  var _super = _createSuper(GoodsList);

  function GoodsList() {
    var _this;

    _classCallCheck(this, GoodsList);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '商品管理'
    }, {
      text: '商品品类',
      to: {
        name: 'GoodsList'
      }
    }];
    _this.options = {
      sortBy: ['createdAt'],
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    };
    _this.filter = {
      title: '',
      statusIndex: -1,
      isbn: ''
    };
    _this.totalNum = 0;
    _this.loading = false;
    _this.headers = [{
      text: '封面',
      value: 'thumb',
      sortable: false
    }, {
      text: 'ISBN',
      value: 'isbn'
    }, {
      text: '商品标题',
      value: 'title'
    }, {
      text: '作者',
      value: 'author'
    }, {
      text: '出版社',
      value: 'press'
    }, {
      text: '状态',
      value: 'status'
    }, {
      text: '价格',
      value: 'price'
    }, {
      text: '添加时间',
      value: 'createdAt'
    }, {
      text: '添加人',
      value: 'managers.createdBy.username',
      sortable: false
    }, {
      text: '操作',
      value: 'actions',
      sortable: false,
      align: 'end'
    }];
    _this.goods = [];
    _this.selectedGoods = [];
    _this.disabledActions = false;
    _this.formatCurrency = formatCurrency;
    _this.isOn = false;
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.actionsHeight = 51;
    return _this;
  }

  _createClass(GoodsList, [{
    key: "mounted",
    value: function mounted() {
      var _this$me$dealer;

      this.onResize();
      this.restorePage(this.cache);
      this.getGoods();
      this.isOn = !!((_this$me$dealer = this.me.dealer) === null || _this$me$dealer === void 0 ? void 0 : _this$me$dealer.ifStoreOpening);

      if (this.getRole() === 'dealer') {
        this.headers.pop();
      }
    }
  }, {
    key: "onOptionsChanged",
    value: function onOptionsChanged() {
      this.getGoods();
    }
  }, {
    key: "selectGoods",
    value: function selectGoods(val) {
      if (val.length > 0) {
        this.disabledActions = false;
      } else {
        this.disabledActions = true;
      }
    }
  }, {
    key: "refreshList",
    value: function () {
      var _refreshList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.filter = {
                  title: '',
                  statusIndex: -1,
                  isbn: ''
                };
                _context.next = 3;
                return this.getGoods();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function refreshList() {
        return _refreshList.apply(this, arguments);
      }

      return refreshList;
    }()
  }, {
    key: "getGoods",
    value: function () {
      var _getGoods = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$options, sortBy, page, itemsPerPage, sortDesc, _this$filter, title, statusIndex, isbn, by, asc, order, paging, where, result;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$options = this.options, sortBy = _this$options.sortBy, page = _this$options.page, itemsPerPage = _this$options.itemsPerPage, sortDesc = _this$options.sortDesc;
                _this$filter = this.filter, title = _this$filter.title, statusIndex = _this$filter.statusIndex, isbn = _this$filter.isbn;
                by = GoodsOrderBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                paging = {
                  skip: itemsPerPage * (page - 1),
                  take: itemsPerPage * page
                };
                where = {
                  title: title || null,
                  isbn: isbn || null,
                  status_EQ: this.statusCodes[statusIndex] || null
                };
                _context2.next = 10;
                return this.queryGoodsRequest(order, paging, where);

              case 10:
                result = _context2.sent;

                if (result) {
                  this.goods = result.goods;
                  this.totalNum = result.paging.totalCount;
                }

                this.loading = false;
                this.storePage();

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getGoods() {
        return _getGoods.apply(this, arguments);
      }

      return getGoods;
    }()
  }, {
    key: "filterQuerySubmit",
    value: function () {
      var _filterQuerySubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getGoods();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function filterQuerySubmit() {
        return _filterQuerySubmit.apply(this, arguments);
      }

      return filterQuerySubmit;
    }()
  }, {
    key: "deleteDialogConfirm",
    value: function () {
      var _deleteDialogConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.deleteGoodsRequest();

              case 2:
                _context4.next = 4;
                return this.getGoods();

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteDialogConfirm() {
        return _deleteDialogConfirm.apply(this, arguments);
      }

      return deleteDialogConfirm;
    }()
  }, {
    key: "routeToDetail",
    value: function routeToDetail(item) {
      this.targetgoods = item;
      this.$router.push({
        name: 'GoodsDetail',
        params: {
          id: item.id + '',
          goodsName: item.title
        }
      });
    }
  }, {
    key: "updateStatusGoods",
    value: function () {
      var _updateStatusGoods = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(val) {
        var msg, goodIds, status, result;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                msg = val ? '上架' : '下架';
                goodIds = this.selectedGoods.map(function (item) {
                  return item.id;
                });
                status = val ? this.GoodsStatus.ON_SHELVES : this.GoodsStatus.OFF_SHELVES;
                _context5.next = 5;
                return this.$apollo.mutate({
                  mutation: changeGoodsStatus,
                  variables: {
                    goodIds: goodIds,
                    status: status
                  }
                });

              case 5:
                result = _context5.sent;

                if (!result) {
                  _context5.next = 13;
                  break;
                }

                showNotification({
                  msg: "".concat(msg, "\u6210\u529F\uFF01"),
                  type: SnackType.Success
                });
                this.selectedGoods = [];
                _context5.next = 11;
                return this.getGoods();

              case 11:
                _context5.next = 14;
                break;

              case 13:
                showNotification({
                  msg: "".concat(msg, "\u5931\u8D25\uFF01"),
                  type: SnackType.Error
                });

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateStatusGoods(_x) {
        return _updateStatusGoods.apply(this, arguments);
      }

      return updateStatusGoods;
    }()
  }, {
    key: "queryGoodsRequest",
    value: function () {
      var _queryGoodsRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(order, paging, where) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.$apollo.query({
                  query: findGoods,
                  variables: {
                    order: order,
                    paging: paging,
                    where: where
                  }
                });

              case 3:
                result = _context6.sent;
                return _context6.abrupt("return", result.data.findGoods);

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                typedError = _context6.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7]]);
      }));

      function queryGoodsRequest(_x2, _x3, _x4) {
        return _queryGoodsRequest.apply(this, arguments);
      }

      return queryGoodsRequest;
    }()
  }, {
    key: "updateShopStatus",
    value: function () {
      var _updateShopStatus = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(isOpening) {
        var _this$me$dealer2, result, msg, typedError;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return this.$apollo.mutate({
                  mutation: openOrCloseStore,
                  variables: {
                    dealerId: (_this$me$dealer2 = this.me.dealer) === null || _this$me$dealer2 === void 0 ? void 0 : _this$me$dealer2.id,
                    isOpening: isOpening
                  }
                });

              case 3:
                result = _context7.sent;

                if (result) {
                  msg = isOpening ? '营业成功！' : '打烊成功！';
                  showNotification({
                    msg: "".concat(msg),
                    type: SnackType.Success
                  });
                  this.isOn = isOpening;
                }

                _context7.next = 11;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);
                typedError = _context7.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 7]]);
      }));

      function updateShopStatus(_x5) {
        return _updateShopStatus.apply(this, arguments);
      }

      return updateShopStatus;
    }()
  }, {
    key: "exportHandler",
    value: function () {
      var _exportHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _this$options2, sortBy, sortDesc, _this$filter2, title, statusIndex, isbn, by, asc, order, where, result, _result$data$exportGo, fileName, contentB64, typedError;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                showNotification({
                  msg: '即将开始下载...',
                  type: SnackType.Info
                });
                _this$options2 = this.options, sortBy = _this$options2.sortBy, sortDesc = _this$options2.sortDesc;
                _this$filter2 = this.filter, title = _this$filter2.title, statusIndex = _this$filter2.statusIndex, isbn = _this$filter2.isbn;
                by = GoodsOrderBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                where = {
                  title: title || null,
                  isbn: isbn || null,
                  status_EQ: this.statusCodes[statusIndex] || null
                };
                _context8.prev = 8;
                _context8.next = 11;
                return this.$apollo.query({
                  query: exportGoodsList,
                  variables: {
                    order: order,
                    where: where
                  }
                });

              case 11:
                result = _context8.sent;

                if (result.data) {
                  _result$data$exportGo = result.data.exportGoodsList, fileName = _result$data$exportGo.fileName, contentB64 = _result$data$exportGo.contentB64;
                  downloadBase64(contentB64, fileName);
                }

                this.loading = false;
                _context8.next = 20;
                break;

              case 16:
                _context8.prev = 16;
                _context8.t0 = _context8["catch"](8);
                typedError = _context8.t0;
                showErrors(typedError.graphQLErrors);

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[8, 16]]);
      }));

      function exportHandler() {
        return _exportHandler.apply(this, arguments);
      }

      return exportHandler;
    }()
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      var actionDom = this.$refs.actions;
      this.actionsHeight = actionDom.clientHeight;
    }
  }, {
    key: "showSelect",
    get: function get() {
      if (this.getRole() === 'dealer') {
        return false;
      } else {
        return true;
      }
    }
  }]);

  return GoodsList;
}(mixins(ListPage, GoodsDialog, AuthFilter));

__decorate([State(function (state) {
  return state.page.GoodsList;
})], GoodsList.prototype, "cache", void 0);

__decorate([Watch('options', {
  deep: true
})], GoodsList.prototype, "onOptionsChanged", null);

__decorate([Watch('selectedGoods', {
  deep: true,
  immediate: true
})], GoodsList.prototype, "selectGoods", null);

GoodsList = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppRefreshAndExport: AppRefreshAndExport,
    AppDialog: AppDialog,
    AppSimpleTextField: AppSimpleTextField,
    AppSimpleSelector: AppSimpleSelector,
    AppDatePicker: AppDatePicker,
    AppSearchBtn: AppSearchBtn,
    AppSelector: AppSelector,
    AppTextField: AppTextField
  }
})], GoodsList);
export default GoodsList;